<template>
  <div v-if="hasPermission">
    <button
      class="messenger-dialogs-button"
      type="button"
      aria-label="add dialog"
      @click.prevent="handleOpenPopup"
    >
      <feather-icon
        icon="PlusIcon"
      />
      Исходящее
    </button>
    <AddClientPopup
      v-if="channelsList.length"
      :key="key"
      :channels="channelsList"
      @close="closePopup"
    />
  </div>
</template>

<script>
import ChatFirst from '@/api/http/models/ChatFirst'
import AddClientPopup from './AddClientPopup'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      hasPermission: false,
      popupIsActive: false,
      channelsList: [],
      key: null
    }
  },

  computed: mapGetters(['authUserCompany']),

  components: {
    AddClientPopup
  },

  async created () {
    this.hasPermission = this.authUserCompany.permissions.includes('wa_chat_api.chat_first')
  },

  methods: {
    async handleOpenPopup () {
      const response = await ChatFirst.getChannels(this.authUserCompany.slug)
      if (response.data && response.data.length) {
        this.key = new Date().getTime()
        this.channelsList = response.data
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Подходящие каналы не найдены',
          text: ''
        })
      }
    },

    closePopup () {
      this.channelsList = []
    }
  }
}
</script>
